module.exports = __webpack_public_path__ + "static/media/YM44_2.7a4dfdd7.jpg";